import { createSlice } from '@reduxjs/toolkit';

const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    slideCount: 5,
    template: {name:'LinkedIn 4:5',height: 46.5, width: 37},
    fontStyles:'Lora + Helvetica',
    backgroundDesign:'Roundly Capsules',
    slides: Array(5).fill({
      tagline: '',
      title: '',
      paragraph: ''
    }),
    currentColorPalletes:{first_color: '#D6DBB2', second_color: '#3C3C3C', third_color: '#e88411'},
    fontSize: 'small',
    fontWeight: 'normal',
    alignment: 'left',
    subscription: false,
    trial: 6,
    faintBackgroundImageUrl: '',
    showFaintBackgroundImages: false,
  },
  reducers: {
     changeSlideCount: (state, action) => {
        if(state.slideCount < 2 || !state.slideCount ){
          state.slideCount = 5;
        }else{
            state.slideCount = action.payload;
        }  
    },
    updateSlideContent: (state, action) => {
      const content = action.payload;
      console.log('content from updateSlideContent:',content);
      
       const newSlides = content.map((_, index) => ({
        tagline: content[index]?.tagline || '',
        title: content[index]?.title || '',
        paragraph: index >0 ?  content[index]?.paragraph : content[index]?.paragraph
      }));
      state.slides = newSlides;
      console.log('state.slides from updateSlideContent:',state.slides, state.slideCount);
    },
    changeTemplate: (state, action) => {
      state.template = action.payload;
    },
    changeFaintBackgroundImageUrl: (state, action) => {
      state.faintBackgroundImageUrl = action.payload;
    },
    changeShowFaintBackgroundImages: (state, action) => {
      state.showFaintBackgroundImages = action.payload;
    },
    changeTrial: (state, action) => {
      console.log('action.payload from changeTrial:',action.payload, state.trial);
      state.trial = action.payload;
    },
    changeSubscription: (state, action) => {
      state.subscription = action.payload;
    },
    changeColorPalletes: (state, action) => {
      state.currentColorPalletes = action.payload.currentColorPalletes;
    },
    changeFontStyle: (state, action) => {
      state.fontStyles = action.payload;
    },
    changeFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
    changeFontWeight: (state, action) => {
      state.fontWeight = action.payload;
    },
    changeFontAlignment: (state, action) => {
      state.alignment = action.payload;
    },
    changeBackgroundDesign: (state, action) => {
      state.backgroundDesign = action.payload;
    },
  },
});


export const { changeSlideCount, changeTemplate, changeFontStyle,
   changeFontSize, changeFontWeight, changeFontAlignment, 
   changeBackgroundDesign, changeColorPalletes, updateSlideContent,
    changeSubscription, changeTrial, changeFaintBackgroundImageUrl, changeShowFaintBackgroundImages } = counterSlice.actions;

export default counterSlice.reducer;
